import React from 'react'
import { FiArrowRight } from '@react-icons/all-files/fi/FiArrowRight'
import { FiMapPin } from '@react-icons/all-files/fi/FiMapPin'
import Action from '../primitives/Action'
import Container from '../foundations/Container'
import styles from './MarketCoverageNotice.module.scss'

const MarketCoverageNotice = ({ content, variant = 'strip' }) => {
  const isBranch = variant === 'branch'

  return (
  <aside className={`${styles.notice} ${isBranch ? styles.branch : ''}`.trim()} aria-label={content?.ariaLabel || 'Florida service areas'}>
    <Container width='wide' className={styles.container}>
      {isBranch && <span className={styles.icon} aria-hidden='true'><FiMapPin /></span>}
      <div>
        <strong>{content?.heading || 'Two Florida service teams'}</strong>
        <span>{content?.body || 'South Florida is served from Miami. Orlando and Central Florida are served from our Orlando warehouse.'}</span>
      </div>
      {content?.cta !== false && (
        <Action
          href={content?.cta?.url || '/orlando'}
          icon={FiArrowRight}
          size='compact'
          variant={isBranch ? 'secondary' : 'plain'}
          className={styles.action}
          dataConversionKey={content?.conversionKey || 'homepage.market-coverage.orlando'}
          dataConversionLocation={content?.conversionLocation || 'after-hero'}
          dataConversionChannel='other'
          dataConversionSalesPath='both'
        >
          {content?.cta?.label || 'View Orlando Services'}
        </Action>
      )}
    </Container>
  </aside>
  )
}

export default MarketCoverageNotice
